// import Link from 'next/link'
import Link from 'next/link'
import Layout from '../components/Layout'
import CookieConsent from 'react-cookie-consent';
import CopyRightNote from '../components/Common/CopyrightNote';
import withSQAccess from '../components/Page/withSQAccess';

const PrivacyPage = () => {
    return (
    <Layout title="Solar Quote Privacy policy">
 {/* <header className="px-4 fixed top-0 w-full z-50 ">
 <nav className="p-3 md:p-5 md:pl-12 container m-auto xl:pl-36 xd:pl-0">
       {!isStateNewJersey && (<Link href="/">
         <img src="/images/logo.png" alt="Solar Quote" className="w-40 xxs:w-60" />
       </Link>)}
       {isStateNewJersey && (<Link href="/">
         <img src="/images/logo-suntiuity.png" alt="Solar Quote" className="w-32 xxs:w-52 object-contain" />
       </Link>)}
 </nav>
</header> */}
      
     
      <div className="pt-4 md:pt-4 home relative flex-col-reverse md:flex-row">
        {/* <div className="block md:hidden mobile-view-banner">

        </div> */}
        <div className="blue-strip hidden 2md:block fixed top-20 left-0 w-10 lg:w-16 xl:w-20 z--1 ">
          <img src="/images/blue-strip.png" alt="blue-strip" />
        </div>
        <div className="p-3 md:p-5 md:pl-12 container m-auto xl:pl-36 xd:pl-0">
          <div className=" w-full m-auto text-left  thnakyou p-4 sm:p-8 flex flex-col justify-center items-start">
            {/* <div className="w-full flex flex-col md:flex-row items-center justify-between"> */}
              {/* <div className="w-full lg:w-1/2"> */}
                <h1 className="mb-2 md:mb-8  main__heading  text-3xl xxs:text-5xl xl:text-6xl font-primaryBold text-titleColor capitalize">
                Privacy Policy
                </h1>
                <p className="mb-4 text-titleColor text-small font-primayRegular">Your privacy is important to Solar Quote Inc along with its ambassadors. This
privacy notice discloses the privacy practices for Solar Quote Inc. with respect
to the information we collect through our website, except where stated
otherwise. This notice will notify you of the following:</p>
<div className="mb-4">
                <label className="flex flex-row xxs:items-center text-bodyColor text-sm xxs:text-base mb-1"> 
                <span className="mt-1.5 xxs:-mt-px bg-primary h-2 xxs:h-2.5 w-2 xxs:w-2.5 rounded-sm mr-2"></span>
                <span className="flex-1">What information we collect;</span>
                </label>
                <label className="flex flex-row xxs:items-center text-bodyColor text-sm xxs:text-base mb-1">
                  <span className="mt-1.5 xxs:-mt-px bg-primary h-2 xxs:h-2.5 w-2 xxs:w-2.5 rounded-sm mr-2"></span>
                  <span className="flex-1">With whom it is shared;</span>
                  </label>
                <label className="flex flex-row xxs:items-center text-bodyColor text-sm xxs:text-base mb-1">
                  <span className="mt-1.5 xxs:mt-0 bg-primary h-2 xxs:h-2.5 w-2 xxs:w-2.5 rounded-sm mr-2"></span>
                  <span className="flex-1"> How it can be corrected;</span>
                </label>
                <label className="flex flex-row xxs:items-center text-bodyColor text-sm xxs:text-base mb-1">
                  <span className="mt-1.5 xxs:-mt-px bg-primary h-2 xxs:h-2.5 w-2 xxs:w-2.5 rounded-sm mr-2"></span>
                  <span className="flex-1"> How it is secured;</span>
                </label>
                <label className="flex flex-row xxs:items-center text-bodyColor text-sm xxs:text-base mb-1">
                  <span className="mt-1.5 xxs:-mt-px bg-primary h-2 xxs:h-2.5 w-2 xxs:w-2.5 rounded-sm mr-2"></span>
                  <span className="flex-1"> How policy changes will be communicated; and</span>
                </label>
                <label className="flex flex-row xxs:items-center text-bodyColor text-sm xxs:text-base">
                  <span className="mt-1.5 xxs:-mt-px bg-primary h-2 xxs:h-2.5 w-2 xxs:w-2.5 rounded-sm mr-2"></span>
                  <span className="flex-1"> How to address concerns over misuse of personal data.</span>
                </label>
                
              </div>
              <h4 className="mt-4 mb-4 text-2xl font-primaryBold text-titleColor">Information collection, use and sharing</h4>
              <p className="mb-4 text-titleColor text-small font-primayRegular">
              Solar Quote will comply with all applicable laws relating to the collection, use and disclosure 
              of personally identifiable information. We are the sole owners of the information collected 
              on this site. We only have access to/collect information that you voluntarily give us via 
              filling out a form, registering on this site, responding to a survey, email or other 
              direct contact from you. We will not sell or rent this information to anyone. 
              At times we may use third-party service providers to collect this data on our website. 
              We will provide all required notifications and obtain all required consents and authorizations 
              from our website visitors and end user customers relating to the disclosure of personally 
              identifiable information to a third-party service provider. No phone number or opt-in consents 
              will be shared with third-party providers.

              </p>
              <p className="mb-4 text-titleColor text-small font-primayRegular">
              Personal information gathered on this site means any information that is
related to an identified person, or that may be used to identify an individual,
including, but not limited to: first and last name; email address; phone number;
a home, postal or other physical address or other contact information; title,
birth date, gender, occupation, industry, or personal interests; and other
information necessary or useful to provide a product or service that you have
requested.
              </p>
              <h4 className="mt-4 mb-4 text-2xl font-primaryBold text-titleColor">How we use information</h4>
              <p className="mb-4 text-titleColor text-small font-primayRegular">
              The information that we collect may be used to provide you with the products, services or information you request, deliver marketing communications or promotional materials that may be of interest to you through various channels (such as through email, on the Online Services, or on third-party websites you visit), improve the services we provide you, measure website activity and generate statistics, improve the usefulness of customer visits, and customize your experience on the Online Services. We also may combine any of the information, both personally identifiable and non-personally identifiable, that we collect through the Online Services and offline.

              </p>
              <h4 className="mt-4 mb-4 text-2xl font-primaryBold text-titleColor">How we share information</h4>
              <p className="mb-4 text-titleColor text-small font-primayRegular">
              We may share information that we collect with our corporate partners and affiliates. We also may share this information with service providers and agents for use on behalf of Solar Quote Inc (e.g., to provide operational and support functions, to deliver marketing communications or promotional materials that may be of interest to you) so that we may better serve your needs. In addition, we may share this information with business partners and third-party service providers for the sole purpose of the provisions to Solar Quote and to provide you with services or offers that you request. We will not share phone numbers or opt-in consents with any third-party or corporate partners. 


              </p>
              <p className="mb-4 text-titleColor text-small font-primayRegular">
              Aside from the above, your personally identifiable information is never sold to or shared with any third party for that party’s independent use.
              </p>
              <h4 className="mt-4 mb-4 text-2xl font-primaryBold text-titleColor">
              Your access to and control over information
              </h4>
              <p className="mb-4 text-titleColor text-small font-primayRegular">
              You may opt out of any future contacts from us at any time. You can do the following at any time by contacting us via the email address or phone number provided on our website:
              </p>
              <div className="mb-4">
                <label className="flex flex-row xxs:items-center text-bodyColor text-sm xxs:text-base mb-1">
                  <span className="mt-1.5 xxs:-mt-px bg-primary h-2 xxs:h-2.5 w-2 xxs:w-2.5 rounded-sm mr-2"></span>
                  <span className="flex-1"> See what data we have about you, if any.</span>
                </label>
                <label className="flex flex-row xxs:items-center text-bodyColor text-sm xxs:text-base mb-1">
                  <span className="mt-1.5 xxs:-mt-px bg-primary h-2 xxs:h-2.5 w-2 xxs:w-2.5 rounded-sm mr-2"></span>
                  <span className="flex-1">Change/correct any data we have about you.</span>
                </label>
                <label className="flex flex-row xxs:items-center text-bodyColor text-sm xxs:text-base mb-1">
                  <span className="mt-1.5 xxs:-mt-px bg-primary h-2 xxs:h-2.5 w-2 xxs:w-2.5 rounded-sm mr-2"></span>
                  <span className="flex-1">Have us delete any data we have about you.</span>
                </label>
                <label className="flex flex-row xxs:items-center text-bodyColor text-sm xxs:text-base mb-1">
                  <span className="mt-1.5 xxs:-mt-px bg-primary h-2 xxs:h-2.5 w-2 xxs:w-2.5 rounded-sm mr-2"></span>
                  <span className="flex-1"> Express any concern you have about our use of your data.</span>
                </label>
                
              </div>
              <h4 className="mt-4 mb-4 text-2xl font-primaryBold text-titleColor">Security</h4>
              <p className="mb-4 text-titleColor text-small font-primayRegular">
              We take precautions to protect your information. We have taken reasonable precautions to protect you against misuse, theft, loss, unauthorized access, disclosure alternation or destruction of your personal information. When you submit sensitive information via the website, your information is protected both online and offline. However, while we strive to protect your personal information, we cannot guarantee the security of our databases or the information that you provide will not be intercepted while being transmitted to us over the Internet.
              </p>
              <h4 className="mt-4 mb-4 text-2xl font-primaryBold text-titleColor">Cookies</h4>
              <p className="mb-4 text-titleColor text-small font-primayRegular">
              We use “cookies” on this site. A cookie is a piece of data stored on a site visitor’s hard drive to help us improve your access to our site and identify repeat visitors to our site. For instance, when we use a cookie to identify you, you would not have to log in a password more than once, thereby saving time while on our site. Cookies can also enable us to track and target the interests of our users to enhance their experience on our site. Usage of a cookie is in no way linked to any personally identifiable information on our site.
              </p>
              <h4 className="mt-4 mb-4 text-2xl font-primaryBold text-titleColor">Your california privacy rights</h4>
              <p className="mb-4 text-titleColor text-small font-primayRegular">
              Beginning January 1, 2005, under California’s “Shine the Light” law, California residents who provide personal information in obtaining products or services for personal, family or household use are entitled to request and obtain from us once per calendar year information about the customer information we shared, if any, with other businesses for their own direct marketing uses. If applicable, this information would include the categories of customer information and the names and addresses of those businesses with which we shared customer information for the immediately prior calendar year (e.g. requests made in 2006 will receive information regarding 2005 sharing activities).
To obtain this information on behalf of Solar Quote Inc, please send an email message to privacy@solarquote.com with “Request for California Privacy Information” in the subject line and in the body of your message. We will provide the requested information to you at your email address in response.
Please be aware that not all information sharing is covered by the “Shine the Light” requirements, and only information on covered sharing will be included in our response.
              </p>
              <h4 className="mt-4 mb-4 text-2xl font-primaryBold text-titleColor">Changes to this privacy policy</h4>
              <p className="mb-4 text-titleColor text-small font-primayRegular">
              Solar Quote Inc.  reserves the right to revise, amend or modify this policy at any time and in any manner. If we make any revisions that materially change the ways in which we use or share the information you previously provided, we will post those changes on this page so that you are aware of the information we collect. Please consult this privacy statement prior to every use for any changes. Unless otherwise noted, all changes will be effective when posted.</p>
              
              <p className="mb-4 text-titleColor text-small font-primayRegular">
              Your consent
              </p>
              <p className="mb-4 text-titleColor text-small font-primayRegular">
              By using our Site, you consent to our online privacy policy.
              </p>
             <p className="mb-4 text-titleColor text-small font-primayRegular"> Contact us</p>
             <p className="mb-4 text-titleColor text-small font-primayRegular">
              
              If there are any questions regarding this privacy policy, you may contact us using the information below: Solar Quote, Inc. 


              </p>
              <Link href="mailto:customerservice@solarquote.com">
             <span className="text-secondary underline cursor-pointer"> customerservice@solarquote.com</span>
        </Link>{' '}
            {/* </div> */}
          </div>
        </div>
      </div>
      <div className="bg-white ">
          <footer className="p-4 pb-10 border-t grid grid-cols-1 items-center  xl:container m-auto">
            <CopyRightNote/>
            {/* <div className="text-right divide-x ">
               <Link href="/">
                <span className=" ml-1 cursor-pointer text-gray-400">Home</span>
              </Link>{' '} 
              
            </div> */}
          </footer>
        </div>
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        declineButtonText="Decline"
        cookieName="solarquote-cookie"
        enableDeclineButton={true}
        expires={365}
        style={{
          width: '100%',
          maxWidth: '100%',
          borderRadius: '0',
          left: '50%',
          transform: 'translateX(-50%)',
          position: 'fixed',
          zIndex: 99,
          background: '#fff',
          color: '#707070',
          border: 'solid 1px #efefef',
          boxShadow: '0 3px 7px rgba(0, 0, 0, 0.3)',
          alignItems: 'center',
          lineHeight: 1.4,
          justifyContent: 'center',
        }}
        buttonStyle={{
          fontSize: '1rem',
          padding: '8px 14px',
          fontFamily: 'ProximaNova-Regular',
          background: 'var(--primary)',
          color: '#fff',
          letterSpacing: '0.025em',
          fontWeight: 400,
          borderRadius: '.25rem',
          margin: '10px 6px',
        }}
        declineButtonStyle={{
          border: '1px solid #999999',
          color: '#666666',
          fontSize: '14px',
          backgroundColor: '#ffffff',
          letterSpacing: '0.025em',
          padding: '8px 14px',
          fontWeight: 400,
          borderRadius: '.25rem',
          margin: '10px',
        }}
        contentStyle={{
          padding: '0px 5px',
          margin: '10px',
          flex: 'initial',
          fontSize: '16px',
          lineHeight: '20px',
          fontFamily: 'ProximaNova-Regular',
        }}
      >
        We use cookies to ensure that we give you the best experience on our
        website. By continuing to use our site, you accept our cookie policy
      </CookieConsent>
    </Layout>
  )
}



export default withSQAccess(PrivacyPage);